








import {Component, Mixins} from 'vue-property-decorator';
import Http from '../mixins/http';
import LocalData from '../mixins/local-data';

@Component({
    components: {},
})

export default class SupportPage extends Mixins(LocalData, Http) {
}
